export const SkillTopPage = [
  {
    title: 'HTML',
    img: 'html',
    exp: '3 years',
  },
  {
    title: 'CSS',
    img: 'css',
    exp: '3 years',
  },
  {
    title: 'JavaScript',
    img: 'js',
    exp: '2 years',
  },
  {
    title: 'React',
    img: 'atom',
    exp: '1 year',
  },
  {
    title: 'Next.js',
    img: 'next',
    exp: '1 year',
  },
  {
    title: 'TypeScript',
    img: 'ts',
    exp: '6 months',
  },
  {
    title: 'TailwindCSS',
    img: 'tailwind',
    exp: '6 months',
  },
];

export default SkillTopPage;
